import type { IconData } from '@stacksjs/iconify-core'

export const foodDrinkDesertIcecream: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6.855 21.33h1.52V9.14H9.9V7.62h4.57v1.52H16v1.53h3.05V9.14h1.53V7.62h1.52v1.52h1.52v12.19h1.53V7.62h1.52V4.57h-1.52V3.05h-1.53V1.52H22.1V0H9.9v1.52H8.375v1.53h-1.52v1.52h-1.52v3.05h1.52ZM16 1.52h3.05v1.53h1.53v1.52h1.52V6.1h-1.52V4.57h-1.53V3.05H16Zm6.095 19.81h1.52v1.53h-1.52Zm-12.19 1.53v1.52h3.05v6.1h1.52v-6.1h3.05v6.1h1.52v-6.1h3.05v-1.52z\"/><path fill=\"currentColor\" d=\"M19.045 16.76h1.53v1.53h-1.53Zm-1.52-3.05h1.52v1.53h-1.52Zm-4.57 4.58h6.09v1.52h-6.09Zm1.52 12.19h3.05V32h-3.05Zm-1.52-16.77h1.52v1.53h-1.52Zm-1.53 3.05h1.53v1.53h-1.53Zm-3.05 4.57h1.53v1.53h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default foodDrinkDesertIcecream
